import { BsUtilReceivers } from "../../dependencies";
import { storeItems } from "../../helpers";
export function addFullBetslipId(config) {
    config.messageCache[config.messageType].receiverIds.push(BsUtilReceivers.FullBetSlip);
    storeItems(config.messageType, config.messageCache, config.items);
}
//# sourceMappingURL=addFullBetslipId.js.map